import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ThemeToggle } from "@/components/layouts/header/theme-toggle";
import { NotificationDropdown } from "@/components/layouts/header/notification-dropdown";
import { TeamSwitcher } from "../sidebar-right/team-switcher";
import { Fragment } from "react/jsx-runtime";

interface Props {
  rightSidebar?: boolean;
  breadcrumb?: { name: string; href: string }[];
}

const breadcrumbData = [
  {
    name: "Shyne Network",
    href: "#",
  },
  {
    name: "Loading...",
    href: "#",
  },
];

export default function InsetHeader({ rightSidebar = true, breadcrumb = breadcrumbData }: Props) {
  return (
    <header className="sticky top-0 flex h-16 shrink-0 items-center gap-2 bg-background z-40 border-b justify-between">
      <div className="flex flex-1 items-center gap-2 px-4">
        <SidebarTrigger />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumb.map((item) => {
              if (item.name === breadcrumb[breadcrumb.length - 1].name) {
                return (
                  <BreadcrumbItem key={item.name}>
                    <BreadcrumbPage>{item.name}</BreadcrumbPage>
                  </BreadcrumbItem>
                );
              }
              return (
                <Fragment key={item.name}>
                  <BreadcrumbItem>
                    <BreadcrumbLink href={item.href}>{item.name}</BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="hidden md:block" />
                </Fragment>
              );
            })}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      <div className="flex items-center gap-2 justify-between pr-6">
        <ThemeToggle />
        {/* <NotificationDropdown /> */}
        {/* TBD: Team switcher here for no right sidebar */}
        {!rightSidebar && <TeamSwitcher />}
      </div>
    </header>
  );
}
